import React from "react";
import { PageTitle } from "../../PageTitle";
import SoftwarePageTemplate, {
  Feature,
  SoftwareSlide,
} from "../SoftwarePageTemplate/SoftwarePageTemplate";
import {
  IconCheckLight,
  IconCalculator,
  IconDatabase,
  IconPassport,
  IconDocument,
  IconBrowser,
  IconNotification,
  IconHeadphones,
} from "../../assets/icons/Icon";
import advancedSearch from "./pictures/advanced-search.png";
import comparison from "./pictures/comparison.png";
import samples from "./pictures/samples.png";
import equipment from "./pictures/equipment.png";
import dashboard from "./pictures/dashboard.png";
import report from "./pictures/report.png";
import blendCheck from "./pictures/blend-check.png";

const slides: SoftwareSlide[] = [
  {
    image: advancedSearch,
    alt: "Интерфейс модуля расширенного поиска CemTest",
    title: "Расширенный поиск",
    description: `Модуль обеспечивает эффективный поиск рецептур в базе данных Вашей лаборатории. Введение фильтров и параметров позволяет быстро находить нужные рецептуры, сокращая время поиска до минимума.`,
  },
  {
    image: comparison,
    alt: "Интерфейс модуля сравнения CemTest",
    title: "Сравнение",
    description: `Модуль предоставляет возможность анализа и сравнения нескольких рецептур, что позволяет выбрать оптимальный вариант в соответствии с конкретными задачами и требованиями.`,
  },
  {
    image: samples,
    alt: "Интерфейс модуля проб CemTest",
    title: "Пробы",
    description: `Модуль предоставляет систему учета и логистики всех проб, собранных в лаборатории. Это обеспечивает точный и структурированный анализ данных для последующего использования.`,
  },
  {
    image: equipment,
    alt: "Интерфейс модуля оборудования CemTest",
    title: "Оборудование",
    description: `Модуль предоставляет инструменты для учета амортизации и калибровки оборудования в лаборатории. Это позволяет эффективно управлять ресурсами и обеспечивать точность получаемых результатов.`,
  },
  {
    image: dashboard,
    alt: "Интерфейс модуля Dashboard CemTest",
    title: "Dashboard",
    description: `Модуль предоставляет обобщенную статистику и ключевые показатели на одном экране, обеспечивая оперативный мониторинг и принятие информированных решений.`,
  },
  {
    image: report,
    alt: "Интерфейс модуля Отчетность CemTest",
    title: "Отчетность",
    description: `Модуль обеспечивает простое и быстрое создание отчетов, предоставляя пользователю гибкие инструменты для форматирования и анализа данных.`,
  },
  {
    image: blendCheck,
    alt: "Интерфейс модуля BlendCheck CemTest",
    title: "BlendCheck",
    description: `Модуль разработан для обеспечения безошибочной навески в лабораторной среде. Система использует технологию сканирования штрих-кода на пробе, что исключает возможность ошибок при навеске.`,
  },
];

const features: Feature[] = [
  {
    name: "Гибкая интеграция",
    icon: IconCheckLight,
    text: "Возможность частичной или полной интеграции с вашими текущими сервисами, обеспечивая максимальную совместимость и удобство.",
  },
  {
    name: "Калькулятор смесей",
    icon: IconCalculator,
    text: "Уникальный инструмент для быстрого и удобного подбора рецептуры, обеспечивающий точную настройку плотности.",
  },
  {
    name: "Перенос базы данных",
    icon: IconDatabase,
    text: "Полный перенос вашей текущей базы данных, гарантирующий беспроблемный переход к новым возможностям приложения.",
  },
  {
    name: "Электронный паспорт",
    icon: IconPassport,
    text: "Возможность хранить всю необходимую документацию электронно, обеспечивая надежное и структурированное хранение информации.",
  },
  {
    name: "Шаблоны",
    icon: IconDocument,
    text: "Создание готовых наборов тестов для моментального ускорения работы лаборатории и инженерного состава.",
  },
  {
    name: "Понятный интерфейс",
    icon: IconBrowser,
    text: "Интуитивно понятный интерфейс, который делает процесс работы с приложением максимально комфортным и эффективным.",
  },
  {
    name: "Система уведомлений",
    icon: IconNotification,
    text: "Удобная и гибкая система уведомлений, позволяющая быть в курсе всех событий вашей лаборатории в режиме реального времени.",
  },
  {
    name: "Техническая поддержка",
    icon: IconHeadphones,
    text: "Постоянно обновляющаяся техническая поддержка, гарантирующая бесперебойную работу Вашей лаборатории.",
  },
];

const CemTest: React.FC = () => {
  return (
    <>
      <PageTitle title="CemTest — Интеллект-Развитие-Технологии" />
      <SoftwarePageTemplate
        key="cemtest"
        id="cemtest"
        title="cemtest"
        subtitle={`Информационная система для автоматизации лаборатории`}
        cardText="Разработано при участии инженеров высочайшего класса — каждый модуль проверен на реальных кейсах, а не только в лаборатории."
        accentText1="CemTest разработан специально для автоматизации процессов в лабораториях, занимающихся тампонажными растворами."
        accentText2="Цель системы - повышение производительности и обеспечение точности данных, получаемых в ходе лабораторных исследований."
        moduleSubheader="CemTest состоит из нескольких модулей, обеспечивающих эффективное хранение, поиск и модификацию данных о тампонажных растворах."
        slides={slides}
        features={features}
      />
    </>
  );
};

export default CemTest;
